var _jsxFileName = "/codebuild/output/src4085722976/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/VerifyNumber/components/FullModalEdit.tsx";
import React from 'react';
import { FullScreenModal, IconClose, Stack } from '@adc/parallax-component-library';
import { Footer, PhoneInput } from 'Components/utility';
import i18n from 'Utilities/i18n';
const InfoModalEdit = ({
  onClose,
  formikForm,
  handleFooterBtnModal,
  isFooterDisabled
}) => {
  const {
    values,
    errors,
    handleChange,
    touched,
    handleBlur
  } = formikForm;
  const topNavigationConfig = {
    title: i18n.t('VerifyMobileNumber.content.editMobileNumber.primaryText'),
    buttonStart: {
      element: /*#__PURE__*/React.createElement(IconClose, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 16
        }
      }),
      label: 'close',
      onPress: onClose
    }
  };
  return /*#__PURE__*/React.createElement(FullScreenModal, {
    topNavigationProps: topNavigationConfig,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FullScreenModal.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    errorMessage: errors.mobileNumber,
    isInvalid: Boolean(errors.mobileNumber) && touched.mobileNumber,
    testID: "mobileNumber",
    value: values.mobileNumber,
    onChangeText: handleChange('mobileNumber'),
    onBlur: handleBlur('mobileNumber'),
    maxLength: 15,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(FullScreenModal.Footer, {
    backgroundColor: "red",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('Global.microcopy.common.save'),
    onButtonPress: handleFooterBtnModal,
    buttonTestID: "VerifyNumberRegistration.continueButton",
    disabled: isFooterDisabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 11
    }
  }))));
};
export default InfoModalEdit;